// Tailwind-compatible mention theme
export const mentionStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    borderRadius: 6,
    border: '1px solid #ddd',
    padding: 8,
    width: '100%',
    maxHeight: 120,
    borderColor: '#dbe2f0',
  },
  highlighter: {
    padding: 9,
    border: '1px solid transparent',
  },
  input: {
    padding: 9,
    outline: 'none',
    border: 'none',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid #dbe2f0',
      fontSize: 14,
      maxHeight: 180,
      overflowY: 'auto' as const,
      overflowX: 'hidden' as const,
      minWidth: 200,
      maxWidth: 210,
      position: 'absolute' as const,
      bottom: 20,
      borderRadius: 10,
    },
    item: {
      padding: '5px 10px',
      borderBottom: '1px solid #8080804d',
      borderRadius: '0px !important',
      '&focused': {
        backgroundColor: '#f6f5ff',
      },
    },
  },
};
